module.exports = __webpack_public_path__ + "img/Barge.3a654bfd.png";